module.exports = __webpack_public_path__ + "img/fastvaluedeal-compare-benefits.d5801325.png";